<template>
<div>
<!-- MAIN CONTAINER -->
<div id="mainContainer">
                    <div id="playBtn" target="Games">
                      <i class="icon" id="playBtnIcn">&#xe800;</i>
                      <div id="clock">--- : --- : ---</div>
                    </div>
</div>
<!-- END OF MAIN CONTAINER -->
</div>
</template>

<script>

export default {
   mounted(){
    this.clock=document.getElementById('clock');
    this.clock.textContent=new Date();
    this.clockInterval=setInterval( function(){ this.clock.textContent=Date();}, 1000);
    this.btn=document.getElementById('playBtnIcn');
    this.addBtnListeners(this.btn);
   },
   beforeDestroy() {
    window.clearInterval(this.clockInterval);
    this.removeBtnListeners(this.btn);
   },

methods:{
    onBtnDown:function(e) {
      window.location.href = 'games/CommandoThug-master/index.html';

    },
    addBtnListeners:function(btn) {

        btn.addEventListener("click",this.onBtnDown,false);

    },
    removeBtnListeners:function(btn) {

        btn.removeEventListener("click",this.onBtnDown);
    }
}//end of method

}
</script>





// WEBPACK FOOTER //
// Home.vue?70b0c24a